import moment from "moment";
import "moment/locale/es";
import "moment/locale/ca";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import enUS from "date-fns/locale/en-US";
import ca from "date-fns/locale/ca";

const dateFnsLocales = { es, en: enUS, ca };

const SUPPORTED_DATE_LOCALES = ["es", "en", "ca"];

// moment already ships ordinals (`Do` → 1st/2nd in en, 1º in es/ca).
// Spanish/Catalan long dates use "de", not the ordinal.
export const LOCALIZED_DATE_FORMATS = {
	es: {
		weekdayLong: "dddd D [de] MMMM [de] YYYY",
		long: "D [de] MMMM [de] YYYY",
		longWithTime: "D [de] MMMM [de] YYYY [a las] HH:mm[h]",
		dayMonthTime: "D [de] MMMM [a las] HH:mm[h]",
	},
	ca: {
		weekdayLong: "dddd D [de] MMMM [de] YYYY",
		long: "D [de] MMMM [de] YYYY",
		longWithTime: "D [de] MMMM [de] YYYY [a les] HH:mm[h]",
		dayMonthTime: "D [de] MMMM [a les] HH:mm[h]",
	},
	en: {
		weekdayLong: "dddd, MMMM Do, YYYY",
		long: "MMMM Do, YYYY",
		longWithTime: "MMMM Do, YYYY [at] HH:mm",
		dayMonthTime: "MMMM Do [at] HH:mm",
	},
};

export function resolveDateLocale(lang = moment.locale()) {
	const base = String(lang || "es").split("-")[0];
	return SUPPORTED_DATE_LOCALES.includes(base) ? base : "es";
}

export function formatLocalizedDate(date, style = "long") {
	if (date == null || date === "") return "";
	const m = moment.isMoment(date) ? date.clone() : moment(date);
	if (!m.isValid()) return "";
	const locale = resolveDateLocale();
	const formats = LOCALIZED_DATE_FORMATS[locale] || LOCALIZED_DATE_FORMATS.es;
	const pattern = formats[style] || formats.long;
	return m.locale(locale).format(pattern);
}

export const registerDateLocales = () => {
	registerLocale("es", es);
	registerLocale("en", enUS);
	registerLocale("ca", ca);
};

export const setDateLocale = (lang) => {
	const locale = resolveDateLocale(lang);

	// moment: "en" is the default, no locale file needed
	moment.locale(locale === "en" ? "en" : locale);

	// react-datepicker
	setDefaultLocale(locale);
};
